import React from "react";
import { connect } from "react-redux";
import SignUp from "../common/SignUp";
import NavItems from "./NavItems";

function Unregistered({ language, ...props }) {
  return (
    <div className="">
      <NavItems tabState={props.tabState} setTabState={props.setTabState} />
      {/* {
        props.store.settings.enable_social_auth &&
        props.store.settings.enable_social_auth_staff &&
        props.tabState == 0 &&
        <div style={{ marginTop: 50 }}>
          <h3
            style={{
              fontFamily: "Quicksand, Cairo",
              marginBottom: 30,
              direction: language == "english" ? "ltr" : "rtl",
            }}
          >
            {language == "english" ? "Join now!" : "انضم الآن!"}
          </h3>
          <SignUp hideSignUpButton />
        </div>
      } */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
  };
};
export default connect(mapStateToProps)(Unregistered);
